import { createSelector } from 'reselect';
export const selectMapAttributionKey = createSelector([(state) => state.config.components], (configComponents) => {
    const key = Object.entries(configComponents).find(([, component]) => component.type === 'MapAttribution')?.[0];
    return key;
});
export const selectMapAttribution = createSelector([(state) => state, selectMapAttributionKey], (state, mapAttributionKey) => {
    return mapAttributionKey ? state[mapAttributionKey] : undefined;
});
//# sourceMappingURL=selectors.js.map